// BIG07 - Transaction Type Code (DE 640), specific to the 810 Invoice.
// Transcribed from reference/session/810-invoice-qualifiers-txt.md.

import type {CodeListEntry} from './types';

export const TRANSACTION_TYPE_CODES: CodeListEntry[] = [
  {code: 'DI', label: 'Debit Invoice'},
  {code: 'CN', label: 'Credit Invoice'},
  {code: 'CR', label: 'Credit Memo'},
  {code: 'DR', label: 'Debit Memo'},
  {code: 'CI', label: 'Consolidated Invoice'},
  {code: 'PR', label: 'Product (or Service)'},
];
